import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import FilterItem from './FilterItem'

class FilterSelector extends Component {
    state = {
        selected: [],
        items: []
    }
    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        state.items = props.items.sort()
        state.selected = props.selected ? (props.singleSelect ? [props.selected] : props.selected) : (props.singleSelect ? undefined : [])
        return state
    }

    onClick(id) {
        let newSelected = this.props.singleSelect ? [] : this.state.selected.filter(item => item !== id);
        if (this.props.singleSelect || newSelected.length === this.state.selected.length) {            
            newSelected.push(id)
        }
        if (!newSelected) {
            newSelected = []
        }
        this.setState({selected : newSelected})

        if (this.props.singleSelect) {
            if (newSelected.length > 0) {                
                this.props.onSelect(newSelected[0])
            } else {
                this.props.onSelect(undefined)
            }
        } else {
            this.props.onSelect(newSelected)
        }
    }

    render() {
        const { t } = this.props;
        let filterItems = []
        this.state.items.forEach(data => {
            filterItems.push(
                <FilterItem id={data} key={data} onClick={this.onClick} selected={this.props.singleSelect ? (data === this.state.selected) : this.state.selected.find(a=>a === data)}/>
            )
        })

        return <div key={this.state.selected} id={this.props.id} >
            {this.props.title ? this.props.title : ""}
            <div className="dropdown show form-control-wrap">
                <button className="dropdown-toggle form-control truncate-text" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {(this.state.selected && this.state.selected !== "") ? (this.props.singleSelect ? (this.state.selected ? this.state.selected =="" ?  this.props.tip : t(this.state.selected) : this.props.tip ) : this.joinWithTranslation(t,this.state.selected, ', ')) : this.props.tip}
                </button>

                <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    {filterItems}
                </div>
            </div>
        </div>
    }

    joinWithTranslation(t, arr, separator) {
        if (arr.length == 0) {
            return this.props.tip 
        }
        let s = ""
        for (let i = 0; i < arr.length; i++) {
            const item = arr[i]
            if (i !== 0) {
                s += separator
            }
            s+=t(item)
        }
        return s
    }
}

export default withRouter(withTranslation()(FilterSelector), FilterSelector);